<span class="sz-num-big">
  <span class="sz-num-big__value">{{ value() }}</span>
  @if (unit(); as unitText) {
    <span class="sz-num-big__unit">{{ unitText }}</span>
  }
</span>
